import React from 'react';
import ReactHtmlParser from '@utils/htmlParser';
import { StyledCloudImage, StyledSection, StyledTextPairing } from './SupportSection.styles';
import { useTranslation } from 'react-i18next';

export const SupportSection = () => {
  const { t } = useTranslation('registry');
  const supportSection = t('supportSection');

  return (
    <StyledSection as="section" id="SupportSection">
      <StyledTextPairing
        alignment="center"
        title={supportSection.title}
        titleTagName="h2"
        titleColor="neutra6"
        titleVariant="hed56"
        body={ReactHtmlParser(supportSection.body)}
        bodyColor="mono1"
        bodyVariant="dek20"
      />
      <StyledCloudImage alt={supportSection.imageAlt} optimization="none" src={supportSection.image} />
    </StyledSection>
  );
};
